export { BioEntitiesAccordion } from './BioEntitiesAccordion.component';
